import { render, staticRenderFns } from "./ReviewYourAnswersRELOC.vue?vue&type=template&id=37ce3a2b"
import script from "./ReviewYourAnswersRELOC.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersRELOC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports